var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-area-drawer",style:([_vm.rectangleStyles, _vm.areaStyles, _vm.textAlignmentStyles])},[_c('span',{style:(_vm.textStyles)},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }